import { render, staticRenderFns } from "./InventarioPilhas.vue?vue&type=template&id=67d053b6&scoped=true"
import script from "./InventarioPilhas.vue?vue&type=script&lang=js"
export * from "./InventarioPilhas.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=67d053b6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d053b6",
  null
  
)

export default component.exports